// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__YOD9V"};